import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { COMPANIES_PATHS } from '../companies';
import { BreadcrumbsService } from '../../../shared/breadcrumbs/breadcrumbs.service';
import { Breadcrumb } from '../../../shared/breadcrumbs/breadcrumbs';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-companies-create',
  templateUrl: './companies-create.component.html',
  styleUrls: ['./companies-create.component.scss'],
  standalone: false,
})
export class CompaniesCreateComponent implements OnInit {
  public companiesCreateBreadcrumbs: Breadcrumb[] = [
    { text: 'Компании', url: COMPANIES_PATHS.companies },
    { text: 'Создание компании', url: null },
  ];

  constructor(private breadcrumbsService: BreadcrumbsService) {}

  ngOnInit() {
    this.breadcrumbsService.updateBreadcrumbs(this.companiesCreateBreadcrumbs);
  }
}
